var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowDownProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "7px",
    viewBox: "0 0 12 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icArrowDownProfile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.92689172,3.02195491 C8.93913918,3.22149287 8.87305909,3.42490294 8.72865146,3.58265761 L4.02485418,8.72120895 C3.78704996,8.9809925 3.38367538,8.99881027 3.12389183,8.76100606 C3.11004691,8.7483325 3.09676827,8.73505387 3.08409472,8.72120895 C2.81785933,8.43036644 2.81785933,7.98434119 3.08409472,7.69349868 L7.36039624,3.02195491 L3.08409472,-1.64958886 C2.81785933,-1.94043137 2.81785933,-2.38645661 3.08409472,-2.67729912 C3.32189893,-2.93708267 3.72527352,-2.95490045 3.98505707,-2.71709623 C3.99890199,-2.70442268 4.01218062,-2.69114405 4.02485418,-2.67729912 L8.72865146,2.46125221 C8.87305909,2.61900689 8.93913918,2.82241695 8.92689172,3.02195491 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit-Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icArrowDownProfile",
    fill: "#333333",
    fillRule: "nonzero",
    transform: "translate(5.906373, 3.021955) scale(-1, 1) rotate(90.000000) translate(-5.906373, -3.021955) ",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowDownProfile);
export default __webpack_public_path__ + "static/media/icArrowDownProfile.43f2893cbb5e8af93fc8e045253a71c9.svg";
export { ForwardRef as ReactComponent };